import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Build better apps faster with the JAMStack",
  "description": "",
  "published": "2020-10-30T00:00:00.000Z",
  "hero": "./img/screenshot-1604075201868.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Imagine your next webapp project. At work or otherwise.`}</p>
    <p>{`You sit down at your keyboard. Wonderful idea in mind, spec in hand, the caffeine is just right, your favorite song plays on `}{`<`}{`insert-streaming-service>, Slack is quiet.`}</p>
    <p>{`You run a single command. It bootstraps your whole project.`}</p>
    <p>{`You add 2 lines of code. It makes everything look good.`}</p>
    <p>{`You code for 10 minutes. 3 hours passed but you didn't notice. Everything flowed. No frustration. No fiddling.`}</p>
    <p>{`You make a pull request. A robot wakes up.`}</p>
    <p>{`It deploys your project on a fresh copy of production infrastructure. You get a custom public URL with your changes.`}</p>
    <p>{`You click the link. Everything works. You share it with beta testers. They love it. You show it to the PM. She thinks you're brilliant.`}</p>
    <p>{`You merge. Code goes to production. Users love it.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/GGg7L9DNKv1VC/giphy-loop.mp4?cid=7cf28b0fyqn3sepydyjl7rff9ezifdv32eludf71b7cjjvwn&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Oh is that not how it usually goes for you my friend? You spend half your time fiddling with your tooling instead of working on your feature? 🤔`}</p>
    <h2 {...{
      "id": "the-jamstack-workshop"
    }}>{`The JAMStack Workshop`}</h2>
    <p>{`Join The JAMStack Workshop and learn how web development works in 2020 and beyond. Drag your organization into the future and they'll thank you later. Never fiddle with the annoying crap on your side projects.`}</p>
    <p><strong parentName="p">{`Focus on your project`}</strong>{`, let your tools handle the rest.`}</p>
    <p><a parentName="p" {...{
        "href": "https://gum.co/PdwnF"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "101.34529147982063%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'406\\'%20viewBox=\\'0%200%20400%20406\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M10%208L9%20115v107h41l-1-14a6398%206398%200%2001-1-27c-2-5%200-11%2010-29%209-17%2016-27%2019-27%202%200%201%207-2%2014l-12%2030c0%202%205-1%206-3%202-2%207-7%2013-10l3-3%204-4%204-3v4c0%207-1%2013-3%2014-7%203-16%2015-26%2035-3%206-1%2012%203%2011%202%200%203%201%204%203%201%203%205%203%205-1%200-2%200-2%202-1l7-3c4-3%206-3%206%201l2%204c3%202-1%208-5%208h-9l153%201h159V8L200%207%2010%208m372%2028l-3%2028-1%2023v20l1%2012h3c3%200%204-1%206-6s2-7%202-28c0-25-1-49-3-51-1-3-4-2-5%202m-186%201l-8%201c-7%200-12%202-5%202%204%200%208%202%206%203-4%202-15%200-13-3%203-3-3-4-11%200l-6%202-4%201-3%201c-4-2-6%202-5%208l1%206%203%204%202%202%202%201c1%201%201%201%203-1%201-2%204-3%205-3l4-1c6-4%2017-5%2017-1%200%201%202%201%202-1h2l2%203c0%201%205%202%209%201l2%201c-1%202%205%201%206%200l1-2%201-3%201-1%203-4c2-7%201-8-4-7s-6%201-4-2c1-1%200-2-1-4-3-3-8-5-8-3m153%2034l-5%201c-6%200-7%201-5%203l-1%203c-2%203-2%204-2%2034a776%20776%200%20002%2041c0%202%203%203%206%202l1%203c0%202%201%202%201-2v-6c-2-2-1-4%201-4l1-1c-2-2%202-1%206%202%206%204%209%204%209%200l2-4%201-3%201-1v-5c0-3%200-6%202-10%202-5%202-6%202-19l-2-15-1-3c-1-5-2-7-4-6-2%200-2%200-2-2%202-4-1-6-10-7l-1-1-1-1-1%201m-149%209l-3%207-2%207v4l1%202c-1%201%201%201%206%201%207%200%208%200%207-2l-3-17c1-1%201-2-1-3s-2-1-5%201m-18%209c-7%203-8%203-19%200-9-2-11%202-3%2010s24%205%2031-5c4-7%201-8-9-5m51-1l-1%202c1%202-2%203-5%201-1-1-2-1-2%201-1%201-1%201-1-1%200-4-3-4-4%200l-1%202c-1%201%203%204%207%204h1l-1-1%201-1c1%201%202%200%203-1h7l2-2c3-3-3-6-6-4m-82%206c0%203%200%205%202%205l1%203%202%203c1%200%202%201%201%203l1%203c1%200%202%201%201%202l1%201%201%203%201%202%201%203%201%203%203%202%202%204%201%205%201%203%201%203c1%204%203%207%204%205v-2l-1-3-1-3c-2%200%200-4%204-8s5-5%204-7l-1-8-1-5h-1l-4-1c-3%200-3-2%200-3%202-1%201-1-3-1-9%200-15-4-19-12l-2-4v4m-11%209v8c0%202%200%202-2-1l-4-5-1%2013%201%2016v7l-1%201%202%201%201%201v2l1%207%202%207c1%201%202%202%201%203l1%201c2-1%202%200%202%202%200%206%206%204%2012-3%204-5%204-5%203-11l-4-17c-2-5-3-6-6-8l-5-3h1l4%201c2%200%202%200%201-4l-3-5c-4-2-5-8-3-12s2-4%200-5-2%200-3%204m166%2031v12h11v-5c1-4%200-5-1-7-3-1-10-2-10%200m-121%2030c0%201%205%205%209%205%2016%203%2020%202%2020-2h-16l-5-1-5-2c-1-1-3-2-3%200m-77%2037l-7%209c-4%204-4%206%201%203l6-3c5-2%207-4%205-7l-1-4c0-4-1-4-4%202m215%202c-2%208%201%2011%2012%209%205%200%206-1%206-6%200-6%200-6-10-6h-8v3M43%20266v5l1%203c-1%202%203%203%206%202l2-3%201-3v-3l-1-2-3-1c-3%200-4%200-6%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/67bd3d0e8102c57641c4862a7faa875c/ca0a1/00W2p7png2e9503.webp 223w", "/static/67bd3d0e8102c57641c4862a7faa875c/75680/00W2p7png2e9503.webp 445w", "/static/67bd3d0e8102c57641c4862a7faa875c/8d1ba/00W2p7png2e9503.webp 890w", "/static/67bd3d0e8102c57641c4862a7faa875c/3838e/00W2p7png2e9503.webp 1335w", "/static/67bd3d0e8102c57641c4862a7faa875c/6a202/00W2p7png2e9503.webp 1444w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/67bd3d0e8102c57641c4862a7faa875c/e92b6/00W2p7png2e9503.png 223w", "/static/67bd3d0e8102c57641c4862a7faa875c/e66bf/00W2p7png2e9503.png 445w", "/static/67bd3d0e8102c57641c4862a7faa875c/4ef49/00W2p7png2e9503.png 890w", "/static/67bd3d0e8102c57641c4862a7faa875c/4e814/00W2p7png2e9503.png 1335w", "/static/67bd3d0e8102c57641c4862a7faa875c/5faa8/00W2p7png2e9503.png 1444w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/67bd3d0e8102c57641c4862a7faa875c/4ef49/00W2p7png2e9503.png",
              "alt": "00W2p7png2e9503",
              "title": "00W2p7png2e9503",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`Live at a zoom link near you on `}<strong parentName="p">{`November 9th at 11am Pacific`}</strong>{`. Can't join live? Full recording is yours forever. Plus you get life-time access to the self-paced version when it's ready.`}</p>
    <h3 {...{
      "id": "heres-how-it-works"
    }}>{`Here's how it works`}</h3>
    <p><a parentName="p" {...{
        "href": "https://gum.co/PdwnF"
      }}>{`Join the workshop`}</a>{` and you get a 20 minutes of pre-video. Like a mini course on the mindset and theory behind the JAMStack.`}</p>
    <p>{`You'll learn about what the JAMStack does for you, why it's fantastic, how it helps in large teams, how it works on side projects, which frameworks to use and why, what the frameworks get you, and how to think about static-first sites.`}</p>
    <p>{`You can think of this portion as `}<em parentName="p">{`The Mindset`}</em>{`. 3 years of research and experimentation condensed into 11 short videos.`}</p>
    <p><strong parentName="p">{`On November 9th, join for the 4 hour live portion`}</strong></p>
    <p>{`4 hours of intense `}<em parentName="p">{`practice`}</em>{`. Try what you learned in a super hands-on workshop. No boring lectures and slides here. Just you, your code, and the rest of the group.`}</p>
    <p>{`I've spent the past several years perfecting my teaching style to make sure you get months worth of value.`}</p>
    <blockquote>
      <p parentName="blockquote">{`I loved the "classroom" feel`}</p>
      <p parentName="blockquote">{`Yes, hands-on real world examples scenarios`}</p>
      <p parentName="blockquote">{`Wow Swizec this was fantastic! It would take us `}<em parentName="p">{`months`}</em>{` to figure this out on our own and you showed us in 4 hours.`}</p>
    </blockquote>
    <p>{`You keep the materials and full recording forever. Share it with your team, come back when you've got a question, it's yours :)`}</p>
    <p>{`Plus you get access to the self-paced version when it's ready.`}</p>
    <h3 {...{
      "id": "what-youll-learn-in-more-detail"
    }}>{`What you'll learn, in more detail`}</h3>
    <p><a parentName="p" {...{
        "href": "https://gum.co/PdwnF"
      }}>{`The JAMStack Workshop`}</a>{` aims to show you the modern tools that make web development insanely productive. What used to take a whole team, you can do yourself.`}</p>
    <p>{`And it's gonna work better, too. Faster, nicer to use, more accessible, better SEO scores, great UX, no loading spinners.`}</p>
    <p>{`The stack we use to achieve that involves:`}</p>
    <ul>
      <li parentName="ul">{`a JAMStack provider like Netlify or Vercel (we'll try both)`}</li>
      <li parentName="ul">{`the mindset`}</li>
      <li parentName="ul">{`Gatsby or NextJS (you'll learn both)`}</li>
      <li parentName="ul">{`a query approach to APIs (we'll try React Query and Apollo Client)`}</li>
      <li parentName="ul">{`a responsive design system (we'll use Theme UI)`}</li>
      <li parentName="ul">{`markdown and MDX for content`}</li>
      <li parentName="ul">{`static-first data loading`}</li>
      <li parentName="ul">{`flexible plugins with component shadowing`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://gum.co/PdwnF"
      }}>{`Join The JAMStack Workshop`}</a>{` today, enrollment closes at midnight.`}</p>
    <p>{`Got questions? Hit reply`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: if $279 is tough right now, `}<a parentName="p" {...{
        "href": "https://gum.co/rhBat"
      }}>{`The JAMStack Workshop is also available in installments`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      